<template>
  <div class="header-content">
    <div class="title">{{ title }}</div>
    <slot name="right" />
  </div>
</template>

<script>
export default {
  props: { title: String }
};
</script>

<style lang="scss" scoped>
@mixin flex-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-content {
  height: 56px;
  border-bottom: rgba(232, 232, 232, 1);
  border-bottom: 1px solid rgba(232, 232, 232, 1);
  padding: 0 32px;
  @include flex-row;
  .title {
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
  }
}
</style>
